import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  itemWrapper: theme => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.VFDivider.tertiary,
    marginTop: 7,
  }),
  description: {
    lineHeight: 23,
    fontSize: 16.6,
    marginVertical: 20,
  },
  itemText: {
    fontSize: 16.6,
    lineHeight: 40,
  },
  divider: theme => ({
    marginTop: 16,
    borderBottomColor: theme.colors.VFDivider.tertiary,
    borderBottomWidth: 1,
  }),
});
